import React from 'react';
import styled from 'styled-components';

const BannerDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

const ImageDiv = styled.div`
  display: inline-block;
  margin: auto;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
`;

const Image = styled.img`
  width: 100%;
  object-fit: cover;
`;

export type BannerProps = {
  imgUrl?: string;
  imgAltText?: string;
  url?: string;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export const Banner: React.FC<BannerProps> = ({
  imgUrl,
  imgAltText,
  url,
  onClick,
}) => {
  return (
    <BannerDiv className="marketing" id="SearchPageGrid-D2">
      <ImageDiv className="image">
        <a href={url} onClick={onClick}>
          <Image src={imgUrl} alt={imgAltText} />
        </a>
      </ImageDiv>
    </BannerDiv>
  );
};
